import { Grid } from '@mui/material';
import React from 'react';
import OverView from './DashboardComponents/OverView';
import OfficerStats from './DashboardComponents/OfficerStats';
import OrganizationCard from './DashboardComponents/OrganizationCard';
import CaseDistributionChart from './DashboardComponents/CaseDistributionChart';
import CaseVolumeByBranch from './DashboardComponents/CaseVolumeByBranch';
import CaseStatusSummary from './DashboardComponents/CaseStatusSummary';
import CasesByBranchStatus from './DashboardComponents/CasesByBranchStatus';
import TopCategories from './DashboardComponents/TopCategories';
import CaseResolutionTime from './DashboardComponents/CaseResolutionTime';
import MostReportedCategories from './DashboardComponents/MostReportedCategories';
import TopSubcategories from './DashboardComponents/TopSubcategories';
import CaseTrendsOverTime from './DashboardComponents/CaseTrendsOverTime';
import CaseCreationTrends from './DashboardComponents/CaseCreationTrends';
import AssignmentAcceptanceRate from './DashboardComponents/AssignmentAcceptanceRate';
import OrganizationPerformanceChart from './DashboardComponents/OrganizationPerformanceChart';

const OrganizationAdminDashboard = () => {





    return (

        <div className='w-full'>
            <Grid container spacing={2}>
                <Grid item size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                    <Grid container spacing={2}>

                        <Grid item size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                            <CaseStatusSummary></CaseStatusSummary>
                        </Grid>

                        <Grid item size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <CaseResolutionTime />
                        </Grid>
                        <Grid item size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                            <AssignmentAcceptanceRate />
                        </Grid>
                    </Grid>

                </Grid>

                <Grid item size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                    <Grid container spacing={2}>
                        <Grid item size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                            <OverView />
                        </Grid>
                        <Grid item size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                            <OfficerStats />
                        </Grid>
                    </Grid>



                </Grid>
                <Grid item size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                    <CaseDistributionChart />
                </Grid>


                <Grid item size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                    <CaseVolumeByBranch />
                </Grid>
                <Grid item size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                    <CasesByBranchStatus />
                </Grid>
                <Grid item size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                    <TopCategories />
                </Grid>

                <Grid item size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                    <MostReportedCategories />
                </Grid>

                <Grid item size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                    <TopSubcategories />
                </Grid>

                <Grid item size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                    <CaseTrendsOverTime />
                </Grid>

                <Grid item size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                    <CaseCreationTrends />
                </Grid>

                <Grid item size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                    <OrganizationPerformanceChart></OrganizationPerformanceChart>
                </Grid>

            </Grid>
        </div>
    );
};

export default OrganizationAdminDashboard; 